$(function ()
{
    "use strict";
    // The native dropdown control on MacOS doesn't support padding, and so browsers on that platform, including Safari
    // and Chrome, don't respect padding styles.  Work around this by setting margins to include what the padding should be,
    // in order to preserve alignment.
    // This should be kept in sync with FormPartial.cs.
    var select = $("<select>", { "css": { paddingTop: "100px", display: "none" } });
    select.appendTo(document.body);
    if (parseInt(select.css("paddingTop")) !== 100)
    {
        var rule =
            "select" +
            "{" +
                "margin-top: 7px;" +
                "margin-bottom: 7px;" +
            "}";
        $("<style>", { text: rule }).appendTo(document.head);
    }
});